// @ts-nocheck

import React, { FunctionComponent, useState } from 'react'
import { useForm } from 'react-hook-form'
import moment from 'moment'
import { Desktop } from 'Shared/components/Responsive'
import Input from 'Containers/ui/Input'
import { IconOrangeAlert, IconSuccessfully } from 'Stories/Icon/Icon.stories'
import { useDispatch, useSelector } from 'react-redux'
import {
  cancelEvent,
  uploadVideo,
  getEventsInProgress,
} from 'Redux/actions/influencerActions'
import { getOpenedCampaign, getEventId } from 'Redux/selectors/influencer'
import { calcTimeLeft } from 'Containers/Tracks/helpers'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { UploadButton } from './UploadButton'
import { ButtonsGroups, Notification, Success } from '../styles'
import { CancelTrack, Container, StyledGreenBtn } from './styles'
import { FormValues, UploadVideoProps } from './types'

export const UploadVideo: FunctionComponent<UploadVideoProps> = ({
  t,
  onClose,
}) => {
  const {
    handleSubmit,
    setValue,
    register,
    control,
    formState: { isSubmitting },
  } = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: { url: '' },
  })
  const campaign = useSelector(getOpenedCampaign)

  const dispatch = useDispatch()
  const eventId = useSelector(getEventId)
  const [uploaded, setUploaded] = useState(false)

  const handleUploading = (error: string) => {
    if (!error) {
      setUploaded(true)
    }
  }
  const submitVideo = (values: FormValues) => {
    dispatch(uploadVideo(values.url, eventId, handleUploading))
  }
  const handleChangeUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('url', e.currentTarget.value)
  }
  const handleCancelClick = () => {
    dispatch(
      cancelEvent(eventId, error => {
        if (!error) {
          dispatch(getEventsInProgress())
          onClose()
        }
      })
    )
  }

  // @ts-ignore
  const timeLeft = calcTimeLeft(campaign?.deadlineToAccept, t)
  const timeForCancel = calcTimeLeft(
    moment(campaign?.startDate).add(7, 'days'),
    t
  )

  const [isPreUpload, setIsPreUpload] = useState(true)

  if (isPreUpload) {
    return (
      <Container>
        <Success>
          <IconSuccessfully />
          <span>{t('influencer.trackAccepted')}</span>
        </Success>
        <Notification>
          <IconOrangeAlert />
          {t('influencer.notificationAfterAccept')}
        </Notification>

        <ButtonsGroups>
          <Desktop>
            <GreenBtn color="white" onClick={onClose}>
              {t('influencer.closeBtn')}
            </GreenBtn>
          </Desktop>

          <UploadButton
            timeLeft={timeLeft}
            t={t}
            onClickUpload={() => setIsPreUpload(false)}
          />
        </ButtonsGroups>
        <CancelTrack onClick={handleCancelClick}>
          {timeForCancel
            ? `${t('influencer.cancelCampaign')} (${timeForCancel})`
            : ''}
        </CancelTrack>
      </Container>
    )
  }

  return (
    <form onSubmit={handleSubmit(submitVideo)}>
      <Container>
        {uploaded ? (
          <Success>
            <IconSuccessfully />
            <span>{t('influencer.videoAdded')}</span>
          </Success>
        ) : (
          <>
            <span>{t('influencer.insertTiktokUrl')}</span>
            <Input
              // @ts-ignore
              name="url"
              {...register('url', { required: true })}
              placeholder={t('influencer.tikTokURL')}
              onChange={handleChangeUrl}
            />
          </>
        )}

        {isSubmitting ? (
          <StyledGreenBtn color="white" disabled>
            {t('influencer.searching')}
          </StyledGreenBtn>
        ) : (
          <>
            <ButtonsGroups>
              <Desktop>
                <GreenBtn color="white" onClick={onClose}>
                  {t('influencer.closeBtn')}
                </GreenBtn>
              </Desktop>

              <UploadButton control={control} timeLeft={timeLeft} t={t} />
            </ButtonsGroups>
            <CancelTrack onClick={handleCancelClick}>
              {timeForCancel
                ? `${t('influencer.cancelCampaign')} (${timeForCancel})`
                : ''}
            </CancelTrack>
          </>
        )}
      </Container>
    </form>
  )
}
